"use client";

import { ReactNode } from "react";

import { getLegalSection, LegalType } from "@/components/legal-content";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";


interface LegalDialogProps {
    type: LegalType;
    children: ReactNode;
}

export function LegalDialog({ type, children }: LegalDialogProps) {
    return (
        <Dialog>
            <DialogTrigger asChild>
                {children}
            </DialogTrigger>
            <LegalDialogContent type={type} />
        </Dialog>
    );
}

function LegalDialogContent({ type }: { type: LegalType }) {
    const section = getLegalSection(type);
    const isSmall = type === "imprint";

    return (
        <DialogContent className={`${isSmall ? "sm:max-w-md" : "sm:max-w-lg max-h-[80vh] overflow-y-auto"} dark text-gray-100 bg-zinc-950 border-zinc-800`}>
            <DialogHeader>
                <DialogTitle>{section.title}</DialogTitle>
                {section.description && (
                    <DialogDescription>{section.description}</DialogDescription>
                )}
            </DialogHeader>
            <div className="py-4">
                {section.content}
            </div>
        </DialogContent>
    );
}
